import { Button, Card, ConfigProvider, Flex, Form, Input, Progress, Spin } from "antd";
import { useEffect, useState } from "react";
import R from './img/3409297.jpg'
import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axios from "axios";

export function ResetPassword(){
    const [form] = Form.useForm();
    const [notsent,setnotsent] = useState(true);
    const [loading,setLoading] = useState(false)
    const [success,setSuccess] = useState(false)
    const [Fail,setFail] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false);
    const { id } = useParams();

    const password = Form.useWatch('password', form);
    const confirmPassword = Form.useWatch('comfirmpassword', form);

    const passwordsMatch = password && confirmPassword && password === confirmPassword;

    useEffect(()=>{
        const setFavicon = (iconUrl: string) => {
            const link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
            if (link) {
              link.href = iconUrl;
            } else {
              const newLink = document.createElement("link");
              newLink.rel = "icon";
              newLink.href = iconUrl;
              document.head.appendChild(newLink);
            }
          };
      
          // Set external image URL as favicon
          setFavicon("https://www.vu.ac.th/wp-content/uploads/elementor/thumbs/vu-main-logo-02-qtm90eapvkc9aj8bjqi1ltncwx61v3ygsveunoi0mu.png");
          document.title = "VU_HREC"; 
    })


    async function Changepassword(){
        setnotsent(false);
        setLoading(true);

        const FormData = form.getFieldsValue();
        const data = {
            password:FormData.user_pass
        }
        console.log(data)
        axios.post(`${process.env.REACT_APP_BASE}/ResetPassword/${id}`,data).then(
            response=>{
                if(response.status==200){
                    setLoading(false)
                    setSuccess(true);
                }else{
                    setLoading(false)
                    setFail(false)
                }
            }
        )

    }

    const handleFormChange = () => {
        const hasErrors = form
        .getFieldsError()
        .some(({ errors }) => errors.length > 0);
        const hasTouched = form.isFieldsTouched(true);
        setIsFormValid(!hasErrors && hasTouched);
    };


    return (<>
    <ConfigProvider
        theme={{
            components: {
                Form: { labelColor: 'black' },
                Segmented: {
                    itemActiveBg: '#D4BDAC',
                    itemSelectedBg: '#FFF1DB',
                    trackBg: 'gray',
                    // itemColor: 'white',
                },
            },
            token: { fontFamily: 'Kanit' },
        }}
    >
         <title>VU HREC</title>
        <div
            style={{
                height: '100vh',
                width: '100vw',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundImage: `url(${R})`,
                backgroundSize: '100% 100%',  
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
        >
             <Card
                style={{
                    width: '50vw',
                    height: '55vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0, // remove internal spacing
                }}
                bodyStyle={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}
                >
                   {notsent&&
                   <>
                    <h1 style={{ marginBottom: 20 }}>ยืนยันการสมัคร</h1>
                        <hr style={{ border: '1px solid black' }} />
                        <Form style={{marginLeft:20}} form={form}
                            onFieldsChange={handleFormChange}
                            >
                            <Form.Item name="user_pass" label="กรุณากรอกรหัสผ่านใหม่"
                            rules={[{ required: true, message: 'กรุณากรอกรหัสผ่าน' }]}
                            hasFeedback>
                                <Input.Password placeholder="กรุณากรอกรหัสผ่านที่มีความยาวไม่เกิน16ตัวอักษร" autoComplete="new-password" name="user_pass"/>
                            </Form.Item>
                            <Form.Item 
                                name="comfirmpassword" 
                                label="กรุณายืนยันรหัสผ่าน"
                                dependencies={['user_pass']}
                                hasFeedback
                                rules={[
                                    { required: true, message: 'กรุณายืนยันรหัสผ่าน' },
                                    ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('user_pass') === value) {
                                        return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('รหัสผ่านของท่านไม่ตรงกัน'));
                                    },
                                    }),
                                ]}
                                >
                                <Input.Password placeholder="กรุณากรอกรหัสผ่านอีกครั้งให้เหมือนกัน" autoComplete="new-password"/>
                            </Form.Item>
                            <Flex justify='flex-end'>
                                <Button disabled={!isFormValid} onClick={()=>Changepassword()} type='primary'>เปลี่ยนรหัสผ่าน</Button>
                            </Flex>
                        </Form>
                    </> ||<>
                    {loading 
                        &&<div
                            style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',  // vertical centering
                            alignItems: 'center',      // horizontal centering
                            height: '100vh',           // full viewport height
                            }}
                            >
                            <Spin indicator={<LoadingOutlined style={{ fontSize: '20vh' }} spin />} />
                            <br/>
                            <h2 style={{ marginTop: 10 }}>ระบบกำลังทำการเปลี่ยนรหัสของท่าน</h2>
                        </div>||<div>
                        <Progress type="circle" percent={100} width={160} />
                            <p>เปลี่ยนรหัสผ่านเสร็จสิ้น กรณาปิดหน้านี้แล้วล็อคอินอีกครั้ง</p>
                        </div>
                        }</>  

                    }

                </Card>
        </div>
    </ConfigProvider>
    </>)
}